import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import Const from 'constants';

class MaxPlayersInLineupValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking, sportConfig} = this.dependencies;

        if (!stacking.isDoubleStackModeEnabled()) {
            return;
        }

        const offencePlayersInLineupQuantity = sportConfig.getConfigProp('offencePlayersInLineup');
        const firstGroupPlayersQuantity = stacking.getFirstGroupPlayersQuantity();
        const secondGroupPlayersQuantity = stacking.getSecondGroupPlayersQuantity();
        const stackingPlayersQuantity = firstGroupPlayersQuantity + secondGroupPlayersQuantity;

        if (offencePlayersInLineupQuantity < stackingPlayersQuantity) {
            this.addError(`Amount of players exceeds ${offencePlayersInLineupQuantity}, please decrease.`);
        }
    }
}

export default MaxPlayersInLineupValidator;
